import api from 'lib/trpcClient';

export default function useEqualisationInterestFeeTemplateOptions(
  vehicleId: string,
) {
  const [equalisationInterestFeeTemplates] =
    api.vehicle.listEqualisationInterestFeeTemplates.useSuspenseQuery(
      {
        vehicleId,
      },
      {
        refetchOnWindowFocus: 'always',
      },
    );

  return equalisationInterestFeeTemplates.map((template) => ({
    value: template.id,
    label: template.name,
  }));
}
